export default __webpack_public_path__ + "static/media/ontraccr-register-img.5fce0280.jpg";